import React, { useEffect, useState } from "react";
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, ResponsiveContainer, Cell 
} from "recharts";
import { Spinner } from "react-bootstrap";

const BarreOrdiniOggi = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const ordini = data?.ORDINI_OGGI?.flat() || [];
        
        // Logica di Somma Importi
        let sommaOF4G = 0;
        let sommaAltri = 0;

        ordini.forEach(item => {
          const valore = parseFloat(item.importo_doc) || 0;
          if (item.tipo_doc === "OF4G") {
            sommaOF4G += valore;
          } else {
            sommaAltri += valore;
          }
        });

        setDataGrafico([
          { name: "URGENTI", totale: sommaOF4G, color: "#b81f25" },
          { name: "ALTRI", totale: sommaAltri, color: "#444444" }
        ]);
        
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch dati:", err);
        setLoading(false);
      });
  }, []);

  // Formattatore per l'euro nel tooltip e negli assi
  const formatEuro = (value) => `${value.toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;

  return (
    <div
      className="bg-white widget-client2 ombra tb"
      style={{ 
        borderRadius: "10px", 
        border: "1px solid #c2c2c2",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="mt-2 text-center">
        <span className="text-title">TIPO ORDINI</span>
      </div>

      <div style={{ flexGrow: 1, width: "100%" }}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical" // Rende le barre orizzontali
              data={dataGrafico}
              margin={{ top: 5, right: 30, left: 20, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#444" horizontal={false} />
              <XAxis type="number" hide /> {/* Nascondiamo l'asse X per pulizia */}
              <YAxis 
                dataKey="name" 
                type="category" 
                stroke="#ccc" 
                fontSize={12} 
                tickLine={false}
              />
              <Tooltip 
                cursor={{ fill: 'transparent' }}
                contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #a7a7a7' }}
                formatter={(value) => [formatEuro(value), "Totale Importo"]}
              />
              <Bar dataKey="totale" radius={[0, 4, 4, 0]} barSize={100}>
                {dataGrafico.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {!loading && (
        <div className="mt-3 mb-1 d-flex justify-content-around" style={{ fontSize: "0.8rem" }}>
          <div>URGENTI: <b style={{ color: "#b81f25" }}>{formatEuro(dataGrafico[0].totale)}</b></div>
          <div>ALTRI: <b style={{ color: "#444444" }}>{formatEuro(dataGrafico[1].totale)}</b></div>
        </div>
      )}
    </div>
  );
};

export default BarreOrdiniOggi;